import { styled } from '@stitches/configed';
import { CSSProperties, FC } from 'react';
import imgLeft from '../../public/img-left.jpg';
import MainWraper from '../Layout/MainWraper';
import Logo from '../../public/logo-login-2.png';
import BoxStyled from '../Common/Box';

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  height: '100vh',
  padding: 8,
  '@sm': {
    padding: 24,
    backgroundColor: '$background',
  },
  variants: {
    fixedHeight: {
      false: {
        height: 'auto',
      },
    },
  },
});
const ImageLeft = styled('div', {
  position: 'relative',
  marginRight: '2rem',
  width: 350,
  '& img': {
    width: '100%',
  },
  display: 'none',
  '@lg': {
    display: 'block',
  },
});
const Right = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  // width: '100%',
  // minWidth: 340,
  width: 540,
  // color: '$t',
});
const LogoTop = styled('img', {
  margin: 'auto',
  marginBottom: '2rem',
  height: 42,
});
const Box = styled(BoxStyled, {
  padding: 16,
  boxShadow: 'none',
  '@xs': {
    padding: 50,
    boxShadow: '$light',
  },
});

type Props = {
  fixedHeight?: boolean;
  rightStyles?: CSSProperties;
  boxStyles?: CSSProperties;
  children?: React.ReactNode;
};
const Layout: FC<Props> = ({
  children,
  fixedHeight,
  rightStyles,
  boxStyles,
}) => {
  return (
    <MainWraper>
      <Container fixedHeight={fixedHeight}>
        <ImageLeft>
          <img src={imgLeft} alt="you-go-vn" />
        </ImageLeft>
        <Right style={rightStyles}>
          <LogoTop src={Logo} alt="logo" />
          <Box style={boxStyles}>{children}</Box>
        </Right>
      </Container>
    </MainWraper>
  );
};

export default Layout;
